import {
  buildQuestionnaireTabOptions,
  withoutQuestionnaireTabStatusIcons,
} from '../../common/hooks';
import { INTAKE_TAB_CONFIGS } from '../constants';
import useIntakeTabStatuses from './useIntakeTabStatuses';
import useIsIntakeQuestionnaireReadOnly from './useIsIntakeQuestionnaireReadOnly';

import type { FButtonMenuOption } from '../../../../components/baseV2';

export default function useIntakeTabMenuOptions(
  basePath: string,
): ReadonlyArray<FButtonMenuOption> {
  const statuses = useIntakeTabStatuses();
  const { isCompleted } = useIsIntakeQuestionnaireReadOnly();
  const options = buildQuestionnaireTabOptions(INTAKE_TAB_CONFIGS, statuses, basePath);

  return isCompleted ? withoutQuestionnaireTabStatusIcons(options) : options;
}
